import React from 'react'
import { useTranslation } from 'react-i18next'
import { useThemeFeatures } from '../../../hooks/useThemeFeatures'
import { FiAlertCircle } from 'react-icons/fi'
import ComponentHeader from '../ComponentHeader/ComponentHeader'
import PanelSurface from '../PanelSurface/PanelSurface'
import styles from './PayoutRateContent.module.css'

interface BetType {
  type: string
  price: string
}

interface PayoutRateContentProps {
  payoutRates: BetType[]
}

const PayoutRateContent: React.FC<PayoutRateContentProps> = ({
  payoutRates,
}) => {
  const { t } = useTranslation()
  const themeFeatures = useThemeFeatures()

  const betTypeKeyMap: Record<string, string> = {
    bet_four: 'betDetailPanel.betLottoType.bet_four',
    bet_run_top: 'betDetailPanel.betLottoType.bet_run_top',
    bet_run_bottom: 'betDetailPanel.betLottoType.bet_run_bottom',
    bet_six: 'betDetailPanel.betLottoType.bet_six',
    bet_three_front: 'betDetailPanel.betLottoType.bet_three_front',
    bet_three_tod: 'betDetailPanel.betLottoType.bet_three_tod',
    bet_three_front_tod: 'betDetailPanel.betLottoType.bet_three_front_tod',
    bet_three_top: 'betDetailPanel.betLottoType.bet_three_top',
    bet_three_under: 'betDetailPanel.betLottoType.bet_three_under',
    bet_two_top: 'betDetailPanel.betLottoType.bet_two_top',
    bet_two_under: 'betDetailPanel.betLottoType.bet_two_under',
    bet_two_tod: 'betDetailPanel.betLottoType.bet_two_tod',
  }

  return (
    <PanelSurface className={styles.payoutRateContent}>
      <ComponentHeader>{t('betRule.payRate')}</ComponentHeader>

      <div className="px-4 md:px-8 py-6 md:py-8 space-y-6">
        <div className="space-y-3">
          <h5 className="text-[var(--bet-type-hover-text)] font-semibold text-base border-b border-[var(--panel-border)] pb-4">
            {t('betRule.betTypeTitle')}
          </h5>
          <div className="space-y-1">
            {payoutRates.map((bet, index) => (
              <div
                key={index}
                className={`flex items-center py-3 ${
                  index < payoutRates.length - 1
                    ? 'border-b border-[var(--panel-border)]'
                    : ''
                }`}
              >
                <div className="flex justify-between items-center w-full">
                  <span className="text-[var(--card-subtext)] text-sm leading-relaxed">
                    {t(betTypeKeyMap[bet.type] || bet.type)}
                  </span>
                  <span className="text-[var(--card-subtext)] text-sm font-extrabold ml-4">
                    {bet.price}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="space-y-3">
          <h5
            className={`font-semibold text-base text-[var(--bet-type-hover-text)] border-b border-[var(--bet-type-hover-text)] pb-4 ${styles.noteTitle}`}
          >
            {t('betRule.note')}
          </h5>
          <div
            className={`${styles.noticeBox} ${themeFeatures.rulesHeaderPadding ? 'payout-notice-box' : ''}`}
          >
            <div className={`flex items-start gap-3 ${styles.noticeContent}`}>
              {themeFeatures.rulesHeaderPadding ? (
                <FiAlertCircle className="text-[var(--notice-icon)] text-3xl flex-shrink-0 mt-1" />
              ) : (
                <span className="text-[var(--card-subtext)] text-sm mt-1.5 flex-shrink-0">
                  •
                </span>
              )}
              <span
                className={`text-[var(--notice-text)] text-sm ${styles.noticeText} leading-relaxed`}
              >
                {t('betRule.t&c')}
              </span>
            </div>
          </div>
        </div>
      </div>
    </PanelSurface>
  )
}

export default PayoutRateContent
